module.exports = __webpack_public_path__ + "static/img/bj_sznr_icon.png";